import React, { useEffect, useState } from "react";
import Layout from "../../components/yenimahalle/Layout";
import BasicHeader from "../../components/yenimahalle/BasicHeader";
import PortalPeopleApi from "../../api/PortalPeopleApi";
import { ManagerList } from "../../models/Response/PortalPeople";
import tw from "twin.macro";
import styled from "styled-components";
import { slugify } from "utils/slugify";

interface CardData {
  imageSrc: string;
  title: string;
  titleText: string;
  link?: string;
  manager: string;
}

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-8`;
const Grid = tw.div`
  grid 
  grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5
  gap-6
  mx-4
`;

const Card = styled.a`
  ${tw`
    flex flex-col h-full w-full 
    sm:border sm:rounded-tl-4xl sm:rounded-br-5xl 
    relative focus:outline-none
    bg-primary-200 text-black
    cursor-pointer transition duration-300
    hover:bg-primary-300 hover:scale-105
  `}
`;

interface CardImageProps {
  imageSrc: string;
}
const CardImage = styled.div<CardImageProps>((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`w-full h-40 sm:h-48 bg-cover bg-center rounded sm:rounded-none sm:rounded-tl-4xl`,
]);

const TextInfo = tw.div`p-4`;
const Title = tw.h5`text-lg font-bold`;
const Manager = tw.p`text-sm font-thin`;

const Mudurlukler: React.FC = () => {
  const [cards, setCards] = useState<CardData[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await PortalPeopleApi.getMudurlukler();
      if (response && response.managerList) {
        const mappedCards = response.managerList.map((item: ManagerList) => ({
          imageSrc: item.managerImageUrl,
          title: item.directorateName,
          titleText: item.managerName,
          link: `/mudurlukdetay/${slugify(item.directorateName)}/${item.directorateId}`,
          manager: item.managerName
        }));
        setCards(mappedCards);
      }
    };

    fetchData();
  }, []);

  return (
    <Layout>
      <BasicHeader headingLine1="" headingLine2="Müdürlükler" />
      <Container>
        <Content>
          <Grid>
            {cards.map((card, index) => (
              <Card key={index} href={card.link || "#"}>
                <CardImage imageSrc={card.imageSrc} />
                <TextInfo>
                  <Title>{card.title}</Title>
                  <Manager>{card.manager}</Manager>
                </TextInfo>

              </Card>
            ))}
          </Grid>
        </Content>
      </Container>
    </Layout>
  );
};

export default Mudurlukler;
